"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var AmountType;
(function (AmountType) {
    AmountType["ORIGINAL_AMOUNT"] = "ORIGINAL_AMOUNT";
    AmountType["AMOUNT_DUE"] = "AMOUNT_DUE";
    AmountType["CURRENT_AMOUNT"] = "CURRENT_AMOUNT";
    AmountType["PAID_AMOUNT"] = "PAID_AMOUNT";
    AmountType["REMITTANCE_AMOUNT"] = "REMITTANCE_AMOUNT";
    AmountType["DISBURSEMENT_AMOUNT"] = "DISBURSEMENT_AMOUNT";
})(AmountType = exports.AmountType || (exports.AmountType = {}));
//# sourceMappingURL=AmountType.js.map